/**
 * Durable localStorage mirror (#1110) — write-through to Connector `web_state.json`.
 * Whitelist is shared with maestro-connector via `web_state_whitelist.json` at repo root.
 */
import whitelistDoc from '../../../web_state_whitelist.json';
import { flushDurableWebStateBackfill, queueDurableWebStateWrite, resetDurableWebStateFlushForTests } from './durableWebStateFlush';
import { waitForDurableWebStateSeed } from './durableWebStateSeed';

const SEED_WAIT_MS = 3000;
const WHITELIST = new Set<string>(whitelistDoc.keys);
let bridgeInstalled = false;

export function resetDurableWebStateBridgeForTests(): void {
  bridgeInstalled = false;
  resetDurableWebStateFlushForTests();
}

export function isDurableWebStateKey(key: string): boolean {
  return WHITELIST.has(key);
}

export function installDurableWebStateWriteThrough(): void {
  if (bridgeInstalled || typeof localStorage === 'undefined') return;
  bridgeInstalled = true;
  const proto = Storage.prototype;
  const origSet = proto.setItem;
  const origRemove = proto.removeItem;
  const origGet = proto.getItem;
  proto.setItem = function durableWebStateSetItem(key: string, value: string) {
    origSet.call(this, key, value);
    queueDurableWebStateWrite(key, value);
  };
  proto.removeItem = function durableWebStateRemoveItem(key: string) {
    origRemove.call(this, key);
    queueDurableWebStateWrite(key, '');
  };
  flushDurableWebStateBackfill(origGet, WHITELIST);
}

export async function hydrateDurableWebStateFromLocalStorage(): Promise<void> {
  await waitForDurableWebStateSeed(SEED_WAIT_MS);
}

export { WEB_STATE_SEED_EVENT, waitForDurableWebStateSeed } from './durableWebStateSeed';
export type { WebStateSeedDetail } from './durableWebStateSeed';
